import React from 'react';
import {Link, useParams} from "react-router-dom";
import {getGeneratedRoute, RouteEnumFinal} from "../../Config/RouteEnum";
import {TabsNavigationEnum} from "./Enum/TabsNavigationEnum";
import {getStoreName} from "../Utils/getStoreName";

const NavbarBottom = (
    {
        firstCategoryCode
    }
) => {
    const storeUsername = getStoreName()

    const params = useParams()
    const targetTab = params["*"]

    return (
        <div className='navbar-bottom d-flex'>
            <div className='container'>
                <div className="row justify-content-between">
                    <div className="col-3">
                        <Link to={`/${firstCategoryCode || 'new'}`} className='td-none'>
                            <div className="d-flex justify-content-center">
                                <div className="img-cnt-24">
                                    {
                                        targetTab === "" &&
                                        <img src="/assets/images/vectors/store_active.svg" alt="store"/>
                                    }
                                    {
                                        targetTab !== "" &&
                                        <img src="/assets/images/vectors/store_inactive.svg" alt="store"/>
                                    }
                                </div>
                            </div>
                            <div
                                className={`cl-icon text-center mt-custom-4 ${targetTab === "" ? 'mobile-body-2-strong' : 'mobile-body-2-regular'}`}>
                                فروشگاه
                            </div>
                        </Link>
                    </div>
                    {/*<div className='col-3'>
                        <Link to={RouteEnum.SHOPPING_CART+sessionStorage.storeCode} className='td-none' >
                            <div className="d-flex justify-content-center">
                                <div className="img-cnt-24">
                                    <img src={"/assets/images/vectors/"+(lastEl===TabsNavigationEnum.SHOPPING_CART ? 'cart_active.svg' : 'cart_inactive.svg')}/>
                                </div>
                            </div>
                            <div className={'cl-icon text-center mt-custom-4 '+(lastEl===TabsNavigationEnum.SHOPPING_CART ? 'mobile-body-2-strong' : 'mobile-body-2-regular')}>
                                سبد خرید
                            </div>
                        </Link>
                    </div>*/}
                    <div className="col-3">
                        <Link to={getGeneratedRoute(RouteEnumFinal.STORE_PANEL_URL_GENERATE)} className='td-none' >
                            <div className="d-flex justify-content-center">
                                <div className="img-cnt-24">
                                    {
                                        targetTab === TabsNavigationEnum.PANEL &&
                                        <img src="/assets/images/vectors/setting_active.svg" alt="store"/>
                                    }
                                    {
                                        targetTab !== TabsNavigationEnum.PANEL &&
                                        <img src="/assets/images/vectors/setting_inactive.svg" alt="store"/>
                                    }
                                </div>
                            </div>
                            <div className={`cl-icon text-center mt-custom-4 ${targetTab===TabsNavigationEnum.PANEL ? 'mobile-body-2-strong' : 'mobile-body-2-regular'}`}>
                                پنل
                            </div>
                        </Link>
                    </div>
                    <div className="col-3">
                        <Link to={getGeneratedRoute(RouteEnumFinal.USER_PROFILE_URL_GENERATE, storeUsername)}
                              className='td-none'>
                            <div className="d-flex justify-content-center">
                                <div className="img-cnt-24">
                                    {
                                        targetTab === TabsNavigationEnum.PROFILE &&
                                        <img src="/assets/images/vectors/profile_active.svg" alt="profile"/>
                                    }
                                    {
                                        targetTab !== TabsNavigationEnum.PROFILE &&
                                        <img src="/assets/images/vectors/profile_inactive.svg" alt="profile"/>
                                    }
                                </div>
                            </div>
                            <div
                                className={`cl-icon text-center mt-custom-4 ${targetTab === TabsNavigationEnum.PROFILE ? 'mobile-body-2-strong' : 'mobile-body-2-regular'}`}>
                                پروفایل
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default NavbarBottom